import type { ApiConnector } from '@/types/accessor/common/connector'
import { type ArgQueryGovernmentSettings } from '@/types/accessor/api/governmentSetting/governmentSetting'
import { queryGovernmentSetting } from '@/accessors/api/requests/disasterCommonGovernmentSettingApiGwFuncs'

export const query: ApiConnector = async (param, indexedDBConnector) => {
  const data = await queryGovernmentSetting(param as ArgQueryGovernmentSettings)
  await indexedDBConnector(data)
  return data
}
